export default "__VITE_ASSET__B7ZLiH_K__"